import { useTranslation } from "react-i18next";
import HiringHeader from "../../../../components/common/layout/HiringHeader";
import Ads from "../../../../components/corporate/hiring/home/Ads";

const AllAds = () => {
    const { t } = useTranslation('common');

    return (
        <div className="w-full h-full min-h-screen bg-white dark:bg-bgDarkDull">
            <HiringHeader />
            <div className="w-full h-full flex flex-col gap-[25px] container py-[34px]">
                <h3 className="text-2xl font-bold text-primaryText dark:text-white">{t("recruitment.hr.home.list")}</h3>
                <Ads listPage={true} />
            </div>
        </div>
    );
};

export default AllAds;